module.exports = __webpack_public_path__ + "static/media/2_step 3.79c67719.PNG";